require('./deletePeriodicLoad.scss');

// @ vendor
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @utilities
const { toCamelCase } = require('utilities/stringHelper');
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');

// @helpers
const DateHelper = require('utilities/dateHelper');

// @constants
const { PERIODICITY } = require('constants/cardPeriodicLoads');
const { EURO_TEXT, DATE_FORMAT_ES }= require('constants/index');

class DeletePeriodicLoad extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    handleCancel() {
        const { cardId } = this.props.match.params;
        this.props.history.push(`/myprofile/cards/${cardId}/movements`);
    }

    isReady() {
        return false;
    }

    searchAssociatedAccountId(accountNumber) {
        const { immAccounts } = this.props;
        const product = accountNumber && accountNumber.substr(0,3);
        const contractNumber = accountNumber && accountNumber.substr(3);

        return immAccounts.get('byOrder').find((accountId) => {
            const account = immAccounts.getIn(['byId', accountId]);
            return account.get('contractNumber') === contractNumber && account.get('product') === product;
        });
    }

    render () {
        const { periodicLoadData, handleDeletePreiodicLoad, cardId, immAccounts } = this.props;
        const accountNumber = periodicLoadData.get('accountNumber');
        const accountObject = immAccounts.getIn(['byId', this.searchAssociatedAccountId(accountNumber)]);
        const originAccountAlias = accountObject.get('alias') || toCamelCase(accountObject.get('accountType'));
        const originAccountText = `${originAccountAlias} ...${accountObject.get('iban').substr(-4)}`;
        const scheduleType = periodicLoadData.get('scheduleType');
        const currency = formatCurrency(EURO_TEXT);
        const amount = getFormattedString({ amount: periodicLoadData.get('transferAmount'), currency });
        const linkToCard = `/myprofile/cards/${cardId}/periodic-loads`;
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const startDate = DateHelper.customFormat(
            periodicLoadData.get('startDate'),
            DATE_FORMAT_ES
        );
        const endDate = DateHelper.customFormat(
            periodicLoadData.get('endDate'),
            DATE_FORMAT_ES
        );
        return (
            <div className="delete-periodic-load">
                <PreLeaveModalComponent
                    acceptText={acceptText}
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    cancelText={cancelText}
                    isReady={this.isReady}
                />
                <h3 className="delete-periodic-load__title">
                    <FormattedText value={`deletePeriodicLoadsView-title`} />
                </h3>
                <p className="delete-periodic-load__sub-title">
                    <FormattedText value={`deletePeriodicLoadsView-subTitle`} />
                </p>
                <div className="delete-periodic-load__detail col-lg-12">
                    <div className="delete-periodic-load__detail-left col-lg-6">
                        <p className="delete-periodic-load__head">
                            <FormattedText value={`cardStatement-chargeAccount`} />
                        </p>
                        <span className="delete-periodic-load__head-value">{originAccountText}</span>
                        <p className="delete-periodic-load__head">
                            <FormattedText value={`deletePeriodicLoadsView-amountLable`} />
                        </p>
                        <span className="delete-periodic-load__head-value">{amount}</span>
                        <p className="delete-periodic-load__head">
                            <FormattedText value={`deletePeriodicLoadsView-periodicity`} />
                        </p>
                        <span className="delete-periodic-load__head-value">{formatText(PERIODICITY[scheduleType])}</span>
                    </div>
                    <div className="delete-periodic-load__detail-right col-lg-6">
                        <p className="delete-periodic-load__head">
                            <FormattedText value={`deletePeriodicLoadsView-startDate`} />
                        </p>
                        <span className="delete-periodic-load__head-value">
                            {startDate}
                        </span>
                        <p className="delete-periodic-load__head">
                            <FormattedText value={`cardPeriodicLoads-endDate`} />
                        </p>
                        <span className="delete-periodic-load__head-value">
                            {endDate}
                        </span>
                    </div>
                </div>
                <footer className="delete-periodic-load__footer">
                    <div className="delete-periodic-load__cancel-button">
                        <OKLink
                            modifier="inherit-styles"
                            to={linkToCard}
                        >
                            <FormattedText value={`cardRequests-cancel`} />
                        </OKLink>
                    </div>
                    <OKButton modifier="primary" onClick={() => {
                        handleDeletePreiodicLoad(periodicLoadData);
                    }}>
                        <FormattedText value={`deletePeriodicLoadsView-confirmBtnLable`} />
                    </OKButton>
                </footer>
            </div>
        )
    }
}
DeletePeriodicLoad.propTypes = {
    cardId: PropTypes.number,
    handleDeletePreiodicLoad: PropTypes.func,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    periodicLoadData: PropTypes.object.isRequired,
};
module.exports = withRouter(DeletePeriodicLoad);
